import moment from 'moment'
import React, { PureComponent } from 'react'
import { Alert, Button, FormControl } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchErrors } from '../../actions/error_management'
import { manualAml } from '../../actions/manual-aml'
import { CalloutBox, DivContentBox } from '../common/styled'

const months = ['Select Month', ...moment.months()]

class IndividualForm extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      first_name: '',
      middle_name: '',
      last_name: '',
      full_name: '',
      formChanged: false,
      loading: false,
      date_of_birth_month: '',
      date_of_birth_day: '',
      date_of_birth_year: '',
      currentYear: new Date().getFullYear(),
      show: false,
    }
  }

  validationMessage = (name) => {
    const { errors } = this.props
    if (errors && errors[name] && !this.state.formChanged) {
      return (
        <div>
          {errors[name].map((e, index) => (
            <span key={index} className='help-block'>
              {e}
            </span>
          ))}
        </div>
      )
    } else {
      return null
    }
  }

  onSubmit = async () => {
    const { props, state } = this

    const {
      first_name,
      middle_name,
      last_name,
      full_name,
      date_of_birth_day,
      date_of_birth_year,
      date_of_birth_month,
    } = state

    let date_of_birth
    if (date_of_birth_day && date_of_birth_year && date_of_birth_month) {
      date_of_birth = `${date_of_birth_year}-${(moment.months().indexOf(date_of_birth_month) + 1)
        .toString()
        .padStart(2, '0')}-${date_of_birth_day}`
    }
    const payload = {
      first_name,
      middle_name,
      last_name,
      full_name,
      date_of_birth,
      aml_type: 'individual',
    }
    this.setState({ show: true })
    await props.manualAml(payload)

    this.setState({
      first_name: '',
      middle_name: '',
      last_name: '',
      full_name: '',
      formChanged: false,
      loading: false,
      date_of_birth_month: '',
      date_of_birth_day: '',
      date_of_birth_year: '',
      currentYear: new Date().getFullYear(),
    })
  }

  changeHandler = ({ target, ...event }) => this.setState({ [target.name]: target.value, formChanged: true })

  validForm = () => {
    const { state } = this

    const validationResult =
      (state.first_name.trim().length && state.last_name.trim().length) || state.full_name.trim().length

    return validationResult
  }

  render() {
    const { state, props } = this
    const { loading, date_of_birth_month, date_of_birth_year, date_of_birth_day, currentYear, show } = state

    const { isFetching, results, disabled } = props

    return (
      <DivContentBox className='ibox-content animated fadeIn'>
        {results && results.message && show && (
          <Alert
            variant={
              results.message.includes('This feature has not been enabled for your account') ? 'danger' : 'success'
            }
            className='animated fadeIn'
            onDismiss={() => this.setState({ show: false })}
          >
            {results.message}
          </Alert>
        )}

        <CalloutBox>
          <h3>
            To perform an AML check on a person who has provided their consent, please follow the below instructions.
          </h3>
          <p>
            For best results split out the name of the individual into First, Middle (if applicable), and Last segments.
          </p>
          <p>
            <b>Required fields:</b>
          </p>
          <ul>
            <li>First Name</li>
            <li>Last Name</li>
            <li>Middle name is optional but will decrease the number of AML results you receive</li>
          </ul>
          <p>
            If you only have one name, or names where it’s not clear how they fit into First, Middle, Last, you can use
            the Full Name field (leaving First, Middle, and Last name fields blank).
          </p>

          <p>
            <b>Examples of when to use the Full Name field:</b>
          </p>
          <ul>
            <li>Names in their native, non-Roman characters</li>
            <li>Single names</li>
            <li>Someone has more than 3 names, common when lineage is part of someone’s name</li>
          </ul>

          <p>
            <b>OPTIONAL:</b> Date of birth: the date of birth of the person you are running AML on. This is optional but
            will reduce the number of AML results you receive.
          </p>
        </CalloutBox>
        <form className='form-horizontal'>
          <fieldset>
            {props.errorMessage && !state.formChanged && (
              <div>
                <Alert variant='danger'>{props.errorMessage}</Alert>
                {props.errorDetails &&
                  props.errorDetails.length > 0 &&
                  props.errorDetails.map((e, index) => (
                    <Alert key={index} variant='danger'>
                      {e}
                    </Alert>
                  ))}
              </div>
            )}
            <div className='form-group'>
              <label className='col-md-4 control-label' htmlFor='first_name'>
                First Name
              </label>
              <div className='col-md-4'>
                <input
                  id='first_name'
                  name='first_name'
                  required
                  placeholder='First Name'
                  className='form-control input-md'
                  disabled={loading}
                  onChange={this.changeHandler}
                  value={state.first_name}
                />
                {this.validationMessage('first_name')}
              </div>
            </div>
            <div className='form-group'>
              <label className='col-md-4 control-label' htmlFor='last_name'>
                Middle Name
              </label>
              <div className='col-md-4'>
                <input
                  id='middle_name'
                  name='middle_name'
                  required
                  placeholder='Middle Name'
                  className='form-control input-md'
                  disabled={loading}
                  onChange={this.changeHandler}
                  value={state.middle_name}
                />
                {this.validationMessage('last_name')}
              </div>
            </div>
            <div className='form-group'>
              <label className='col-md-4 control-label' htmlFor='last_name'>
                Last Name
              </label>
              <div className='col-md-4'>
                <input
                  id='last_name'
                  name='last_name'
                  required
                  placeholder='Last Name'
                  className='form-control input-md'
                  disabled={loading}
                  onChange={this.changeHandler}
                  value={state.last_name}
                />
                {this.validationMessage('last_name')}
              </div>
            </div>
            <div className='form-group'>
              <label className='col-md-4 control-label' htmlFor='full_name'>
                Full Name*
              </label>
              <div className='col-md-4'>
                <input
                  id='full_name'
                  name='full_name'
                  required
                  placeholder='Full Name'
                  className='form-control input-md'
                  disabled={loading}
                  onChange={this.changeHandler}
                  value={state.full_name}
                />
                {this.validationMessage('last_name')}
              </div>
            </div>
            <div className='form-group'>
              <label className='col-md-4 control-label' htmlFor='date_of_birth_month'>
                Month
              </label>
              <div className='col-md-4'>
                <select
                  style={{ minWidth: 100 }}
                  name={'date_of_birth_month'}
                  className={'form-control'}
                  value={date_of_birth_month}
                  placeholder='select'
                  onChange={this.changeHandler}
                >
                  {months.map((m) => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='form-group'>
              <label className='col-md-4 control-label' htmlFor='date_of_birth_day'>
                Day
              </label>
              <div className='col-md-4'>
                <FormControl
                  placeholder={'Day'}
                  type='number'
                  value={date_of_birth_day}
                  name={'date_of_birth_day'}
                  max={31}
                  min={1}
                  onChange={this.changeHandler}
                />
              </div>
            </div>
            <div className='form-group'>
              <label className='col-md-4 control-label' htmlFor='date_of_birth_year'>
                Year
              </label>
              <div className='col-md-4'>
                <FormControl
                  placeholder={'Year'}
                  type='number'
                  value={date_of_birth_year}
                  name={'date_of_birth_year'}
                  min={1920}
                  max={currentYear}
                  onChange={this.changeHandler}
                />
                <div style={{ marginTop: 5 }}>
                  * NOTE: Using Full Name instead of putting records into individual First and Last Name fields may
                  produce lower quality results
                </div>
              </div>
            </div>
            <div className='form-group'>
              <label className='col-md-4 control-label' />
              <div className='col-md-4'>
                {disabled && (
                  <Button variant='primary' disabled>
                    Submit
                  </Button>
                )}
                {!disabled && (
                  <Button variant='primary' onClick={this.onSubmit} disabled={!this.validForm() || isFetching}>
                    Submit
                  </Button>
                )}
              </div>
            </div>
          </fieldset>
        </form>
      </DivContentBox>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  errorMessage: state.manualAml.errorMessage,
  errors: state.manualAml.errors,
  results: state.manualAml.results,
  isFetching: state.manualAml.isFetching,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manualAml,
      fetchErrors,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IndividualForm))
